import React, { useEffect, useState } from 'react';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import ProcedureForm from './ProcedureForm';
import ReactDOM from 'react-dom';
import Typography from '@material-ui/core/Typography';
import Wrapper from '../components/Wrapper';
import { getProcedure } from '../services/procedures';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    '& > *': {
      margin: '0.5rem 0',
    },
  },
  card: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4),
  },
  mb: {
    marginBottom: theme.spacing(3),
  },
  notesCard: {
    backgroundColor: theme.palette.primary.dark,
    color: 'white',
  },
}));

const ProcedurePreview = () => {
  const [data, setData] = useState(null);
  const [step, setStep] = useState('menu');
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const id = new URLSearchParams(window.location.search).get('procedureId');
  const [procedureType, setProcedureType] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: procedureData } = await getProcedure(id);
        setData(procedureData);
        setProcedureType(procedureData.procedure_pattern);
      } catch (err) {
        enqueueSnackbar('Nie udało się pobrać danych', {
          variant: 'error',
        });
        console.error(err);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (step === 'menu') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [step]);

  const format = (date) => new Date(date).toLocaleDateString();

  return (
    <div className={classes.root}>
      {data && step === 'menu' && (
        <>
          <Typography variant='h6'>Nazwa procedury</Typography>
          <Typography variant='body1'>{data.name}</Typography>
          <Typography variant='h6'>Opis procedury</Typography>
          <div>
            <Typography
              variant='body1'
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          </div>
          <Typography variant='h6'>Harmonogram</Typography>
          {(procedureType === 'Wnioski' ||
            procedureType === 'Uwagi i wnioski') && (
            <Typography variant='h6'>
              Składanie wniosków: od{' '}
              {data.submit_start ? format(data.submit_start) : '-'} do{' '}
              {data.submit_end ? format(data.submit_end) : '-'}
            </Typography>
          )}
          {(procedureType === 'Uwagi' ||
            procedureType === 'Uwagi i wnioski') && (
            <Typography variant='h6'>
              Składanie uwag: od{' '}
              {data.comments_start ? format(data.comments_start) : '-'} do{' '}
              {data.comments_end ? format(data.comments_end) : '-'}
            </Typography>
          )}

          <Grid container spacing={2}>
            {(procedureType === 'Wnioski' ||
              procedureType === 'Uwagi i wnioski') && (
              <Grid item xs={12} md={6}>
                <Card className={classes.card}>
                  <Typography variant='h4' className={classes.mb}>
                    Składanie wniosku
                  </Typography>

                  <Typography variant='h6' className={classes.mb}>
                    Wypełnij wniosek, aby podzielić się z nami opinią:
                  </Typography>
                  {typeof access !== 'undefined' && access !== 'False' ? (
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={() => setStep('request')}
                    >
                      <Typography variant='button'>Wypełnij wniosek</Typography>
                    </Button>
                  ) : (
                    <Typography>
                      Usługa wymaga autoryzacji profilem zaufanym
                    </Typography>
                  )}
                </Card>
              </Grid>
            )}
            {(procedureType === 'Uwagi' ||
              procedureType === 'Uwagi i wnioski') && (
              <Grid item xs={12} md={6}>
                <Card className={`${classes.card} ${classes.notesCard}`}>
                  <Typography variant='h4' className={classes.mb}>
                    Składanie uwag
                  </Typography>
                  <Typography variant='h6' className={classes.mb}>
                    Wypełnij formularz, aby podzielić się z nami uwagami:
                  </Typography>
                  {typeof access !== 'undefined' && access !== 'False' ? (
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={() => setStep('notes')}
                    >
                      <Typography variant='button'>Wypełnij wniosek</Typography>
                    </Button>
                  ) : (
                    <Typography>
                      Usługa wymaga autoryzacji profilem zaufanym
                    </Typography>
                  )}
                </Card>
              </Grid>
            )}
          </Grid>
        </>
      )}
      {(step === 'notes' || step === 'request') && (
        <ProcedureForm
          setStep={setStep}
          step={step}
          procedure={data}
          procedureId={id}
        />
      )}
    </div>
  );
};

export default ProcedurePreview;

ReactDOM.render(
  <Wrapper overrideService='pp' productionPrefix='prp' seed='procedure-preview'>
    <ProcedurePreview />
  </Wrapper>,
  document.getElementById('procedure-preview'),
);
